
// Imports to manually trigger a modal popup on a specific route
import { defineAsyncComponent } from 'vue';
import { useModalStore } from '@/store/modalStore';

const TriggerModal = (to : any) => {
    const modalStore = useModalStore();

  console.groupCollapsed(`[Router] Navigation: ${to.path}`);

  if (to.path === '/admin_panel/demo') {
    console.log('✅ Matched /admin_panel/demo - Triggering Modal');
    modalStore.openModal(
      'please share your experience with us',
      'We would love to hear your feedback on the demo. Your insights help us improve our platform.',
      defineAsyncComponent(() => import('@/components/AdminComponents/Questionnaires/QuizComponent.vue')),
    );
  } else {
    console.log('ℹ️ No modal trigger for this route');
  }

  console.groupEnd();

}

export { TriggerModal }; // Export the function for use in the router